import { React, useState, Typography, Grid2, CustomTextField, CustomDatePicker, CustomDropdown, Box, CustomButton, CustomRadioButton, Divider, SelectChangeEvent, Dayjs, useLocation } from "../../utils/globalImports";
import { CustomAddPartiesInvolvedModal, useApi, useEffect, Paper, dayjs, ViewFramework, CustomDataTableModal, CustomMultiSelectDropdown, useOutletContext, useParams, CustomDataTable, Toaster, FilterCard, validationMessages } from "../../utils/globalImports";
import { ApiResponse } from '../../services/apiService';


const defaultFrameworkOption = [
  {
    value: 1,
    text: 'RSK BSL Frameworks'
  }
];

export interface ClientContact {
  contactId?: number;
  clientName: string
  firstName: string;
  lastName: string;
  mobileNo: string;
  emailAddress: string;
  status?: boolean;
}

const General: React.FC = () => {

  const [formData, setFormData, setInitialFormData, errors, setErrors] = useOutletContext<any>();
  const { execute } = useApi();
  const [selectedStatus, setSelectedStatus] = useState<any>([1]);
  const [clientOptions, setClientOptions] = useState<Option[]>([]);
  const [frameworkOptions, setFrameworkOptions] = useState<Option[]>([]);

  const [defaultFramework, setDefaultFramework] = useState<Framework[]>([]);

  const [defaultClientName, setDefaultClientName] = useState('');
  const [clientname, setClientname] = useState('');
  const [clientAssociatedFramework, setClientAssociatedFramework] = useState<Framework[]>([]);

  const [tagOptions, setTagOptions] = useState<Option[]>([]);
  const [technicalLeadOptions, setTechnicalLeadOptions] = useState<Option[]>([]);
  const [assistantLeadOptions, setAssistantLeadOptions] = useState<Option[]>([]);
  const [bidCoordinatorOptions, setBidCoordinatorOptions] = useState<Option[]>([]);
  const [projectManagerOptions, setProjectManagerOptions] = useState<Option[]>([]);
  const [assistantManagerOptions, setAssistantManagerOptions] = useState<Option[]>([]);
  const { projectId } = useParams();
  const isEditMode = Boolean(projectId);
  const [isOn, setIsOn] = useState<boolean>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [toast, setToast] = useState({ open: false, message: "", type: "success" });
  const [openPartiesModal, setOpenPartiesModal] = useState(false);
  const handleClosePartiesModal = () => setOpenPartiesModal(false);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [selectedParty, setSelectedParty] = useState<any | null>(null);
  const [partiesData, setPartiesData] = useState<Contact[]>([]);
  const [currentStatus, setCurrentStatus] = useState<boolean | string[]>(true);
  const userId = Number(localStorage.getItem("userId"));
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const clientIdFromQuery = searchParams.get('clientId');
  const [clientContactList, setClientContactList] = useState<ClientContact[]>([]);

  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  type Row = {
    [key: string]: string;
  };

  type Option = {
    value: string | number;
    text: string;
  };

  type Client = {
    clientId: number;
    clientName: string;
    status: number;
  };

  type Tag = {
    proposalTagId: number;
    proposalTag: string;
    status: number;
  };

  type Personnel = {
    personnelId: number;
    firstName: string;
    lastName: string;
    userTypes: number[];
    status: boolean;
  };

  type Role = {
    roleId: number;
    roleName: string;
  }

  type User = {
    userId: number;
    firstName: string;
    lastName: string;
    roleId: number;
    roleName: string;
    status: number;
  }

  type Contact = {
    projectPartyId?: number;
    firstName: string;
    lastName: string;
    contactType: string;
    company: string;
    emailAddress: string;
    mobileNo: string;
    status: number;
  }

  interface Framework {
    frameworkId: number;
    frameworkName: string;
    clientId: number;
    clientName: string;
    status: boolean;
    startDate: Dayjs | null;
    endDate: Dayjs | null;
    projectNames: string;
  }

  const handlePartiesSubmit = async (partyFormData: any) => {
    try {
      const requestBody = {
        projectId: projectId,
        firstName: partyFormData.firstName,
        lastName: partyFormData.lastName,
        type: partyFormData.contactType,
        company: partyFormData.company,
        emailAddress: partyFormData.emailAddress,
        mobileNo: partyFormData.mobileNo || "",
        status: 1,
        createdId: selectedParty ? selectedParty.createdId : userId,
        updatedId: userId,
        createdAt: selectedParty ? selectedParty.createdAt : new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };

      let response;

      if (selectedParty) {
        const updatedParty: Contact = {
          ...selectedParty,
          ...requestBody,
        };

        try {
          response = await execute("put", "/Project/UpdateProjectParty", updatedParty);

          if (response) {
            if (response.error) {
              setToast({ open: true, message: response.error, type: "error" });
            } else {
              setToast({ open: true, message: "Party updated successfully", type: "success" });
              fetchAllParties();
              // setPartiesData((prevList) =>
              //   prevList.map((party) =>
              //     party.projectPartyId === selectedParty.projectPartyId ? updatedParty : party
              //   )
              // );
            }
          }
        } catch (error) {
          console.error("Error updating party:", error);
          setToast({ open: true, message: "Error updating party", type: "error" });
        }
      } else {
        const newParty: Contact = {
          projectPartyId: 0,
          contactType: partyFormData.contactType,
          ...requestBody,
        };

        try {
          response = await execute("post", `/Project/AddProjectParty/${projectId}`, newParty);

          if (response) {
            if (response.error) {
              setToast({ open: true, message: response.error, type: "error" });
            } else {
              setToast({ open: true, message: "Party added successfully", type: "success" });
              fetchAllParties();
            }
          }
        } catch (error) {
          console.error("Error adding party:", error);
          setToast({ open: true, message: "Error adding party", type: "error" });
        }
      }

      handleClosePartiesModal();
    } catch (error) {
      console.error("Error in handlePartiesSubmit:", error);
      setToast({ open: true, message: "An unexpected error occurred", type: "error" });
    }
  };


  // const showGrid = (updatedData: any[],status = [true]) => {
  //   const partyData = updatedData.map((party: any) => ({
  //     partyId: party.projectPartyId,
  //     Status: party.status === 1 ? 'Active' : 'Inactive',
  //     name: `${party.firstName} ${party.lastName}`,
  //     email: party.emailAddress || "N/A",
  //     type: party.type,
  //   }));

  //   // Sorting by name, then email
  //   const sortedData = partyData.sort((a, b) =>
  //     a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }) ||
  //     a.email.localeCompare(b.email, undefined, { sensitivity: 'base' })
  //   );

  //   setFilteredData(sortedData);
  // };
  const showGrid = (updatedData: any[], status = [1]) => {
    const data = updatedData
      .filter((party: any) => status.includes(party.status))   // ✅ Filter first
      .map((party: any) => {
        const Status = party.status === 1 ? "Active" : "Inactive";

        return {
          partyId: party.projectPartyId,
          name: `${party.firstName} ${party.lastName}`,
          email: party.emailAddress || "N/A",
          type: party.type,
          Status
        };
      })
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" }) ||
        a.email.localeCompare(b.email, undefined, { sensitivity: "base" })
      );

    setFilteredData(data);
  };

  // Auto-select client when clientIdFromQuery is available
  useEffect(() => {
    if (!initialDataLoaded) return; // ensure clientOptions are loaded
    if (!clientIdFromQuery) return; // only run for add project with query

    const parsedId = Number(clientIdFromQuery);
    if (!parsedId) return;

    // Check if client exists in dropdown
    const selectedOption = clientOptions.find(c => c.value === parsedId);
    if (!selectedOption) return;

    // Set formData for dropdown
    setFormData((prev: any) => ({
      ...prev,
      associatedClient: parsedId,
    }));

    // Also set selected client name
    setClientname(selectedOption.text);

    // Fetch dependent data
    fetchClientAssociatedFrameworks(parsedId);
    fetchAllContacts();

  }, [initialDataLoaded, clientOptions, clientIdFromQuery]);


  useEffect(() => {
    showGrid(partiesData, selectedStatus);
  }, [partiesData]);

  const handleToggleState = (row: any) => {
    if (row.Status === 'Inactive') {
      setIsOn(false)
    } else {
      setIsOn(true)
    }
    setSelectedParty(row);
    setDialogOpen(true);
  }

  const handleEdit = (party: any | null) => {
    if (party) {

      if (!Array.isArray(partiesData)) {
        return;
      }

      // Find full party details
      const fullPartyDetails = partiesData.find((p: any) => p.projectPartyId === party.partyId);

      if (!fullPartyDetails) {
        console.warn("Full details not found for party:", party);
        return;
      }

      const fullName = party.name.split(" "); // Split "FirstName LastName"

      const reconstructedContact: Contact = {
        projectPartyId: fullPartyDetails.projectPartyId || undefined,
        firstName: fullName[0] || "",
        lastName: fullName.slice(1).join(" ") || "",
        contactType: (fullPartyDetails as any).type || "",
        company: fullPartyDetails.company || "",
        emailAddress: fullPartyDetails.emailAddress || "",
        mobileNo: fullPartyDetails.mobileNo || "",
        status: fullPartyDetails.status === 1 ? 1 : 0,
      };

      setSelectedParty((prev: any) => ({ ...prev, ...reconstructedContact }));
      setFormData((prev: any) => ({ ...prev, ...reconstructedContact }));
    } else {
      setSelectedParty(null);
      setFormData((prev: any) => ({
        ...prev,
        firstName: "",
        lastName: "",
        contactType: "",
        company: "",
        emailAddress: "",
        mobileNo: formData.mobileNo?.trim() ? formData.mobileNo.trim() : null,
        status: 1, // Default to Active
      }));
    }

    setOpenPartiesModal(true);
  };

  const handleOpenPartiesModal = () => {
    setSelectedParty(null);
    setOpenPartiesModal(true);
  };

  const handleDialogCancel = () => {
    setDialogOpen(false);
    setSelectedParty(null);
  };

  const handleDialogConfirm = async () => {
    if (!selectedParty) {
      return;
    }
    try {
      const updatedParty = partiesData.find(
        (party: Contact) => Number(party.projectPartyId) === Number(selectedParty.partyId)
      );

      if (!updatedParty) {
        return;
      }

      const newStatus = updatedParty.status === 1 ? 0 : 1;

      // Ensure all fields have valid values
      const updatedPartyData = {
        projectPartyId: updatedParty.projectPartyId,
        projectId: projectId,  // Required field
        firstName: updatedParty.firstName || "",
        lastName: updatedParty.lastName || "",
        type: (updatedParty as any).type || "",
        company: (updatedParty as any).company || "N/A",
        emailAddress: updatedParty.emailAddress,
        mobileNo: (updatedParty as any).mobileNo || "",
        status: newStatus,
        updatedId: userId,
        updatedAt: dayjs().toISOString(),
      };

      let response: ApiResponse<any> = await execute("put", "/Project/UpdateProjectParty", updatedPartyData);

      if (response!) {
        if (response.error) {
          // If there's an error in the response, display the error message
          setToast({ open: true, message: response.error, type: "error" });
        } else {
          // If the response is successful, display the success message
          setToast({ open: true, message: response.data.message, type: "success" });
        }
      }

      fetchAllParties();
      setSelectedParty(null);
    } catch (error) {
      console.error("Failed to update party status:", error);
    } finally {
      setDialogOpen(false);
    }
  };

  // const handleSearchGridData = (
  //   query: string,
  //   status: number, // Status filter value
  //   category?: number,
  //   region?: number,
  //   contactType?: number,
  //   date?: string
  // ) => {
  //   const lowerCaseQuery = query.toLowerCase();

  //   // Status mappings
  //   const statusMapping: Record<number, string> = {
  //     1: "Active",
  //     0: "Inactive",
  //   };

  //   // Update `currentStatus` state properly
  //   setCurrentStatus(
  //     status === -1 || status === 2
  //       ? ["Active", "Inactive"]
  //       : status === 1
  //         ? ["Active"]
  //         : ["Inactive"]
  //   );
  //   // Apply filters
  //   const filtered = partiesData.filter((party: Contact) => {
  //     const partyStatus = party.status === 1 ? "Active" : "Inactive"; // Ensure consistent status mapping
  //     const fullName = `${party.firstName} ${party.lastName}`.toLowerCase();
  //     const matchesQuery = fullName.includes(lowerCaseQuery) ||
  //       (party.firstName.toLowerCase().includes(lowerCaseQuery)) ||
  //       (party.lastName.toLowerCase().includes(lowerCaseQuery)) ||
  //       (party.emailAddress.toLowerCase().includes(lowerCaseQuery));
  //     const matchesStatus =
  //       status === -1 || // Show all
  //       status === 2 || // Show both
  //       partyStatus === statusMapping[status]; // Exact match

  //     return matchesQuery && matchesStatus;
  //   });

  //   setFilteredData(filtered);
  //   showGrid(filtered);
  // };
  const handleSearchGridData = (
    query: string,
    status: number,
    category?: number,
    region?: number,
    contactType?: number,
    date?: string
  ) => {
    const lowerCaseQuery = query.toLowerCase();

    const filtered = partiesData.filter((party: Contact) => {

      const matchesQuery =
        `${party.firstName} ${party.lastName}`.toLowerCase().includes(lowerCaseQuery) ||
        party.firstName.toLowerCase().includes(lowerCaseQuery) ||
        party.lastName.toLowerCase().includes(lowerCaseQuery) ||
        party.emailAddress.toLowerCase().includes(lowerCaseQuery);

      const matchesStatus =
        status === -1 ||
        status === 2 ||
        party.status === status;

      return matchesQuery && matchesStatus;
    });


    const newStatus =
      status === 0
        ? [0]
        : status === -1 || status === 2
          ? [1, 0]
          : [1];

    setSelectedStatus(newStatus);

    showGrid(filtered, newStatus);
  };

  const sortOptions = [
    { value: "name", text: "Name" },
    { value: "email", text: "Email" },
  ];

  const props = { showNotesComments: false, projectId: projectId, title: false, actionText: "Add Party", searchbarText: validationMessages.parties_searchText }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value, // Dynamically update status based on selection
    });
  };


  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await fetchClients();
        await fetchTags();
        await fetchPersonnel();
        await fetchUsers();
        // await fetchDefaultFrameworks();

        setInitialDataLoaded(true); // signal that first useEffect is done
      } catch (error) {
        console.error('Error loading initial data:', error);
      }
    };

    fetchInitialData();
  }, []); // runs on mount


  useEffect(() => {
    const fetchEditModeData = async () => {
      if (isEditMode && initialDataLoaded) {
        await fetchAllParties();
        await fetchClientAssociatedFrameworks(formData.associatedClient);
        const selectedOption = clientOptions.find(opt => opt.value === Number(formData.associatedClient));
        if (selectedOption) setClientname(selectedOption.text)

        await fetchAllContacts();
      }
    };

    fetchEditModeData();
  }, [initialDataLoaded, projectId]); // runs only after initial data is loaded


  const fetchClients = async () => {
    const { data } = await execute('get', '/Client/GetAllClients');
    if (data && Array.isArray(data)) {
      const clientOptions = data
        .filter(client => client.status) // Filter for active framework
        .map(client => ({
          value: client.clientId,
          text: client.clientName
        }))
        .sort((a, b) => a.text.trim().localeCompare(b.text.trim(), undefined, { sensitivity: 'base' })); // Case-insensitive sorting;;
      setClientOptions(clientOptions);

      // fetch RSK Frameworks
      const rskClient = data.find(c => c.isDefault);
      if (rskClient) {
        setDefaultClientName(rskClient.clientName)
      }
    }
  };

  // fetch Cleint Contacts 
  const fetchAllContacts = async () => {
    const { data } = await execute<ClientContact[]>('get', `/Client/GetAllClientContacts/${formData.associatedClient}`);
    if (data && Array.isArray(data)) {

      const contacts = data
        .filter(contact => contact.status)
        .map((contact) => {
          const {
            contactId,
            clientName,
            firstName,
            lastName,
            emailAddress,
            mobileNo,
          } = contact;

          return {
            contactId,
            clientName,
            firstName,
            lastName,
            emailAddress,
            mobileNo
          }
        })

      setClientContactList(contacts)
    }
  }


  const fetchframeworks = async (clientId: number) => {
    const { data } = await execute<Framework[]>('get', `/Framework/GetFrameworkByClientId/${clientId}`);
    if (data && Array.isArray(data)) {
      return data.filter(framework => framework.status); // Filter for active framework
    }
  }

  const fetchClientAssociatedFrameworks = async (clientId: number) => {
    const frameworkOptions = await fetchframeworks(clientId)
    if (frameworkOptions && Array.isArray(frameworkOptions)) {

      if (frameworkOptions.length > 0) {

        const clientFramework = frameworkOptions.filter(x => x.clientId === Number(clientId))
        setDefaultFramework(frameworkOptions.filter(x => x.clientId !== Number(clientId)))
        if (clientFramework.length > 0) {
          setClientAssociatedFramework(clientFramework)
          const clientFrameworkOption = [
            {
              value: 0,
              text: `${clientFramework[0].clientName} Frameworks`,
            }
          ];

          setFrameworkOptions([
            ...defaultFrameworkOption,
            ...clientFrameworkOption,
          ]);

          setFormData((prev: any) => ({
            ...prev,
            associatedFrameworkGroup: 0,
          }));

          setInitialFormData((prev: any) => ({
            ...prev,
            associatedFrameworkGroup: 0,
          }));

          return;
        }
      }

      setFrameworkOptions(defaultFrameworkOption);
      setClientAssociatedFramework([])
      setFormData((prev: any) => ({
        ...prev,
        associatedFrameworkGroup: 1,
      }));

      setInitialFormData((prev: any) => ({
        ...prev,
        associatedFrameworkGroup: 1,
      }));
    }
  };

  const fetchTags = async () => {
    const { data } = await execute('get', '/Lookup/GetAllProposalTags');
    if (data && Array.isArray(data)) {
      const tagsOptions = data
        .filter(tag => tag.status) // Filter for active tags
        .map(tag => ({
          value: tag.proposalTagId,
          text: tag.proposalTag
        }))
        .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })); // Case-insensitive sorting;;
      setTagOptions(tagsOptions);
    }
  };

  const fetchPersonnel = async () => {
    const { data } = await execute<Personnel[]>('get', '/Lookup/GetAllPersonnel');
    if (data) {
      const activePersonnel = data.filter(person => person.status === true); // Only active personnel
      const technicalLeads = activePersonnel
        .filter(person => person.userTypes.includes(1)) // Technical Project Lead
        .map(person => ({
          value: person.personnelId.toString(),
          text: `${person.firstName} ${person.lastName}`
        }));

      const assistantLeads = activePersonnel
        .filter(person => person.userTypes.includes(2)) // Assistant Technical Project Lead
        .map(person => ({
          value: person.personnelId.toString(),
          text: `${person.firstName} ${person.lastName}`
        }));

      setTechnicalLeadOptions(technicalLeads);
      setAssistantLeadOptions(assistantLeads);
    }
  };


  const fetchUsers = async () => {
    const { data } = await execute<User[]>('get', '/User/GetAllUsers');
    if (data && Array.isArray(data)) {
      const users = data
        .filter(user => user.status === 1) // Filter for active tags
        .sort((a, b) => a.firstName.localeCompare(b.firstName, undefined, { sensitivity: 'base' })); // Case-insensitive sorting;

      const formatUserOptions = (roleName: string) =>
        users
          .filter(user => user.roleName === roleName || user.roleName === 'Admin') // Admin will default for Delivery Team
          .map(user => ({
            value: user.userId.toString(),
            text: `${user.firstName} ${user.lastName}`
          }));

      setBidCoordinatorOptions(formatUserOptions('Bid Coordinator'));
      setProjectManagerOptions(formatUserOptions('Project Manager'));
      setAssistantManagerOptions(formatUserOptions('Assistant Project Manager'));
    }
  };

  // fetch All Parties 
  const fetchAllParties = async () => {
    const { data } = await execute<Contact[]>('get', `/Project/GetAllProjectParties/${projectId}`);
    if (data && Array.isArray(data)) {
      setPartiesData(data)
      showGrid(data, selectedStatus); // Send updated list to showGrid
    }
  }

  return (
    <Box sx={{ flexGrow: 1 , pb: 2}}>
      <Paper elevation={0} sx={{ border: '1px solid #e0eaf6', borderRadius: '14px', overflow: 'hidden', marginBottom: 2 }}>
        <Typography sx={{ fontSize: "25px", color: "#1e66ab", fontWeight: 600, ml: 0, display: 'flex', px: 2.5, py: 1.5, backgroundColor: '#f0f6ff', borderBottom: '1px solid #e0eaf6' }}>
          Details:
        </Typography>
        <Grid2 container spacing={2} sx={{ px: 2.5, py: 1.5, backgroundColor: '#f7faff' }}>
          {/* Left Column */}
          <Grid2 size={{ xs: 12, md: 6, lg: 6 }} sx={{ flexGrow: 1,  paddingRight: 2 }}>
            <CustomTextField
              label="Project Number"
              name="projectNumber"
              value={formData.projectNumber}
              onChange={handleChange}
              sx={{ mb: 1, backgroundColor: '#fff' }}
              required={true}
              disable
            />
            {errors.projectNumber && (
              <Typography className="validationMessage" role="alert">
                {errors.projectNumber}
              </Typography>
            )}

            <CustomDatePicker
              label="Start Date"
              required={true}
              value={formData.startDate}
              onChange={(newValue) => setFormData({ ...formData, startDate: newValue })}
              disabled={formData.isExistProposal}
              // onChange={(newValue) => handleStartDateChange(newValue)}
              sx={{ mb: 1, backgroundColor: '#fff' }}
            />
            {errors.startDate && (
              <Typography className="validationMessage" role="alert">
                {errors.startDate}
              </Typography>
            )}

            <Box sx={{ position: 'relative', overflow: 'visible' }}>
              <CustomDropdown
                value={formData.associatedClient}
                onChange={async (event) => {
                  const selectedClientId = Number(event.target.value);
                  const selectedOption = clientOptions.find(opt => opt.value === selectedClientId);
                  if (selectedOption) {
                    setClientname(selectedOption.text);
                  }
                  // Update client ID in form data
                  setFormData((prev: any) => ({
                    ...prev,
                    associatedClient: selectedClientId,
                  }));
                  await fetchClientAssociatedFrameworks(selectedClientId);
                }}

                label="Associated Client"
                options={clientOptions}
                requiredLabel={true}
                sx={{ mb: 1, backgroundColor: '#fff' }}
                disable={projectId || clientIdFromQuery ? true : false}
              />
              {errors.associatedClient && (
                <Typography className="validationMessage" role="alert">
                  {errors.associatedClient}
                </Typography>
              )}
            </Box>

            <CustomMultiSelectDropdown
              selectedValues={formData.projectTags}
              onChange={(event) => setFormData({ ...formData, projectTags: event.map(Number) })}
              label="Project Tags"
              options={tagOptions}
              requiredLabel
              required={false}
              sx={{ height: '35px' }}
            />

            <Box sx={{ mt: 4.5}}>
              <Typography sx={{ color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1, mt: 1, }}>
              Status
            </Typography>
            <Grid2 sx={{ display: "flex" }}>
              <CustomRadioButton
                label="Active"
                name="status"
                value="Active"
                checked={formData.status === "Active"}
                onChange={handleChange}
                required={true}
              />
              <CustomRadioButton
                label="Inactive"
                name="status"
                value="Inactive"
                checked={formData.status === "Inactive"}
                onChange={handleChange}
                required={true}
              />
            </Grid2>
            </Box>
            
          </Grid2>

          {/* Right Column */}
          <Grid2 size={{ xs: 12, md: 6, lg: 6 }} sx={{ flexGrow: 1, paddingLeft: 2 }}>
            <CustomTextField
              label="Project Name"
              name="projectName"
              value={formData.projectName}
              onChange={handleChange}
              sx={{ mb: 1, backgroundColor: '#fff' }}
              required={true}
            />
            {errors.projectName && (
              <Typography className="validationMessage" role="alert">
                {errors.projectName}
              </Typography>
            )}

            <CustomDatePicker
              label="End Date"
              required={true}
              value={formData.endDate}
              onChange={(newValue) => {
                if (!newValue) {
                  setFormData({ ...formData, endDate: null });
                  setErrors((prev: any) => ({ ...prev, endDate: "End date is required" }));
                  return;
                }

                // ✅ validation
                const minAllowed = formData.proposalMaxEndDate || formData.startDate;
                const isBeforeMin = minAllowed && newValue.isBefore(minAllowed, "day");

                if (isBeforeMin) {
                  setErrors((prev: any) => ({
                    ...prev,
                    endDate: `End date cannot be earlier than proposal End date ${minAllowed.format("DD-MM-YYYY")}`,
                  }));
                  setFormData({ ...formData, endDate: newValue }); // keep typed value
                } else {
                  setErrors((prev: any) => ({ ...prev, endDate: "" })); // clear error
                  setFormData({ ...formData, endDate: newValue });
                }
              }}
              sx={{ mb: 1, backgroundColor: '#fff' }}
              minDate={formData.proposalMaxEndDate || formData.startDate} // still restrict calendar
            />

            {errors.endDate && (
              <Typography className="validationMessage" role="alert">
                {errors.endDate}
              </Typography>
            )}

            <CustomTextField
              label="Project Description"
              name="projectDescription"
              value={formData.projectDescription}
              onChange={handleChange}
              sx={{ mb: 1, backgroundColor: '#fff' }}
              required={false}
              isTextArea={true}
            />
            {errors.projectDescription && (
              <Typography className="validationMessage" role="alert">
                {errors.projectDescription}
              </Typography>
            )}
          </Grid2>
        </Grid2>
      </Paper>


      <Paper elevation={0} sx={{ border: '1px solid #e0eaf6', borderRadius: '14px', overflow: 'hidden', marginBottom: 2 }}>
             {frameworkOptions.length > 0 && (
        <Box>
          {/* <Divider sx={{ mt: 2, mb: 4 }} /> */}

          <Typography sx={{ fontSize: "16px", color: "#1e66ab", fontWeight: 600, display: 'flex', px: 2.5, py: 1.5, backgroundColor: '#f0f6ff', borderBottom: '1px solid #e0eaf6' }}>
            Framework
          </Typography>

          <Grid2 container spacing={2} sx={{px: 2.5, py: 1.5, backgroundColor: '#f7faff'}}>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }} sx={{ flexGrow: 1,  paddingRight: 2 }}>
              <CustomDropdown
                value={formData.associatedFrameworkGroup}
                onChange={(event) => {
                  const selectedValue = Number(event.target.value); // ensure correct type
                  setFormData({ ...formData, associatedFrameworkGroup: selectedValue });
                }}

                label="Associated Framework Group"
                options={frameworkOptions}
                requiredLabel={true}
                sx={{ mb: 1, backgroundColor: '#fff'}}
              />
              {errors.associatedFrameworkGroup && (
                <Typography className="validationMessage" role="alert">
                  {errors.associatedFrameworkGroup}
                </Typography>
              )}

              <ViewFramework data={defaultFramework} name={defaultClientName} ></ViewFramework>

              {frameworkOptions.length > 1 && formData.associatedFrameworkGroup === 0 && (
                <ViewFramework data={clientAssociatedFramework} name={clientname} ></ViewFramework>
              )}


            </Grid2>
          </Grid2>
        </Box>
      )}
      </Paper>
     





      {/* <Divider sx={{ mt: 2, mb: 4 }} /> */}
      <Paper elevation={0} sx={{ border: '1px solid #e0eaf6', borderRadius: '14px', overflow: 'hidden', marginBottom: 2 }}>
         <Typography
        sx={{fontSize: "16px", color: "#1e66ab", fontWeight: 600, display: 'flex', px: 2.5, py: 1.5, backgroundColor: '#f0f6ff', borderBottom: '1px solid #e0eaf6'}}
      >
        Delivery Team
      </Typography>

       <Grid2 container spacing={2}  sx={{px: 2.5, py: 1.5, backgroundColor: '#f7faff'}}>
        {/* Left Column */}
        <Grid2
          size={{ xs: 12, md: 6, lg: 6 }}
          sx={{ flexGrow: 1, paddingRight: 2 }}
        >
          <CustomDropdown
            value={formData.bidCoordinator}
            // onChange={(e) => handleStatusChange(e, "bidCoordinator")}
            onChange={(event) => setFormData({ ...formData, bidCoordinator: Number(event.target.value) })}
            label="Bid Coordinator"
            options={bidCoordinatorOptions}
            requiredLabel={true}
            sx={{ mb: 2, backgroundColor: '#fff' }}
            required={false}
          />

          <CustomDropdown
            value={formData.projectManager}
            onChange={(event) => setFormData({ ...formData, projectManager: Number(event.target.value) })}
            // onChange={(e) => handleStatusChange(e, "projectManager")}
            label="Project Manager"
            options={projectManagerOptions}
            requiredLabel={true}
           sx={{ mb: 2, backgroundColor: '#fff' }}
            required={false}
          />

          <CustomDropdown
            value={formData.technicalProjectLead}
            onChange={(event) => setFormData({ ...formData, technicalProjectLead: Number(event.target.value) })}
            //onChange={(e) => handleStatusChange(e, "technicalProjectLead")}
            label="Technical Project Lead"
            options={technicalLeadOptions}
            requiredLabel={true}
            sx={{ mb: 2, backgroundColor: '#fff' }}
            required={false}
          />
        </Grid2>

        {/* Right Column */}
        <Grid2
          size={{ xs: 12, md: 6, lg: 6 }}
          sx={{ flexGrow: 1, marginTop: 10.5, paddingLeft: 2 }}
        >
          <CustomDropdown
            value={formData.assistantProjectManager}
            onChange={(event) => setFormData({ ...formData, assistantProjectManager: Number(event.target.value) })}
            // onChange={(e) => handleStatusChange(e, "assistantProjectManager")}
            label="Assistant Project Manager"
            options={assistantManagerOptions}
            requiredLabel={true}
            sx={{ mb: 2, backgroundColor: '#fff' }}
            required={false}
          />

          <CustomDropdown
            value={formData.assistantTechnicalProjectLead}
            onChange={(event) => setFormData({ ...formData, assistantTechnicalProjectLead: Number(event.target.value) })}
            // onChange={(e) =>
            //   handleStatusChange(e, "assistantTechnicalProjectLead")
            // }
            label="Assistant Technical Project Lead"
            options={assistantLeadOptions}
            requiredLabel={true}
            sx={{ mb: 2, backgroundColor: '#fff' }}
            required={false}
          />
        </Grid2>
      </Grid2>
      </Paper>
     
     
      {isEditMode && (
        <>
          {/* <Divider sx={{ mt: 2, mb: 4 }} /> */}
          <Typography
            sx={{ fontSize: "16px", color: "#1e66ab", fontWeight: 600, ml: 1 }}
          >
            Parties Involved
          </Typography>
{/* 
          <Grid2 container spacing={2}>
          </Grid2> */}
          <CustomAddPartiesInvolvedModal
            open={openPartiesModal}
            onClose={handleClosePartiesModal}
            onSubmit={handlePartiesSubmit}
            contactData={selectedParty}
            clientContacts={clientContactList}
          />
          <Box sx={{ mt: '-0.5%' }}>
            <FilterCard {...props} handleSearch={handleSearchGridData} handleModalOrNavigate={handleOpenPartiesModal}></FilterCard>
          </Box>
          {partiesData.length > 0 && (
            <CustomDataTable
              rows={filteredData}
              actionText="Parties Involved"
              sortOptions={sortOptions}
              onRowEdit={handleEdit}
              onToggleClick={handleToggleState}
              isDialogOpen={dialogOpen}
              isToggleOn={isOn}
              handleCancel={handleDialogCancel}
              handleConfirm={handleDialogConfirm}
              noResultMessage={validationMessages.common_RecordNotFound("parties involved")}
            />
          )}
          <Toaster
            open={toast.open}
            message={toast.message}
            type={toast.type as "success" | "error"}
            onClose={() => setToast({ ...toast, open: false })}
          />
        </>
      )}
    </Box>
  );
}

export default General;